import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import { useLocale } from '../contexts/LocaleContext'
import { APP_STORE_URL, PLAY_STORE_URL, getPlatform } from '../constants/stores'

const HIDDEN_ON = ['/download', '/coach-invite', '/notifications', '/account-deletion']
const DISMISS_KEY = 'gj-download-bar-dismissed'

function MobileDownloadBar() {
  const { t } = useLocale()
  const location = useLocation()
  const [platform] = useState(getPlatform)
  const [scrolled, setScrolled] = useState(false)
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === '1')

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 480)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const path = location.pathname.replace(/^\/fr/, '') || '/'
  const hiddenOnPage = HIDDEN_ON.some((p) => path.startsWith(p))

  if (platform === 'desktop' || hiddenOnPage || dismissed) return null

  const storeUrl = platform === 'ios' ? APP_STORE_URL : PLAY_STORE_URL

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1')
    setDismissed(true)
  }

  return (
    <AnimatePresence>
      {scrolled && (
        <motion.div
          className="mobile-download-bar"
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ type: 'spring', stiffness: 380, damping: 32 }}
        >
          <img src="/assets/logo_no_bg.svg" alt="" width="40" height="40" />
          <div className="mobile-download-bar-text">
            <strong>Gym Journey</strong>
            <span>{t.download.barSubtitle}</span>
          </div>
          <a className="btn primary" href={storeUrl} rel="noopener">
            <span>{t.download.barCta}</span>
          </a>
          <button type="button" className="mobile-download-bar-close" onClick={dismiss} aria-label={t.download.close}>
            ×
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default MobileDownloadBar
